<template>
<div class="vip">
	<titles :vipState="vipState"></titles>
	<headers :vipState="vipState" :card-state="cardState" @showDialog="showDialog" @showHyxy="showHyxyDialog"></headers>
	<my-privileges :vipState="vipState" :card-state="cardState" @showDialog="showDialog" @showCompensateDialog="showCompensateDialog" @showAuthDialog="showAuthDialog"></my-privileges>
	<job-analysis :vipState="vipState"></job-analysis>
	<!-- <privileges @showDialog="showDialog" @showCompensateDialog="showCompensateDialog" @showAuthDialog="showAuthDialog" :vipState="vipState" :card-state="cardState"></privileges> -->
	<footers></footers>
	<help></help>
	<!-- 投保提示 -->
	<tbts-dialog @closeDialog="closeDialog" v-if="showTbts"></tbts-dialog>
	<!-- 个人认证提示 -->
	<AuthDialog @closeDialog="closeDialog" v-if="showAuth"></AuthDialog>
	<BuyDialog :cardChoose="cardChoose" @closeDialog="closeDialog" @showHyxy="showHyxyDialog" v-if="show"></BuyDialog>
	<hyxy-dialog v-if="showHyxy" @closeDialog='closeDialog' :stopPrevent="false"></hyxy-dialog>
</div>
</template>
<script>
import Titles from '../modules/title/Title'
import Headers from '../modules/header/Header'
import MyPrivileges from '../modules/myPrivileges/MyPrivileges'
// import Privileges from '../modules/privileges/Privileges'
import JobAnalysis from '../modules/jobAnalysis/JobAnalysis'
import Help from '../modules/help/Help'
import Footers from '../modules/footer/Footer'
import BuyDialog from '../modules/dialog/BuyDialog'
import TbtsDialog from '../modules/dialog/TbtsDialog' // 投保提示
import AuthDialog from '../modules/dialog/AuthDialog' // 个人认证提示
import HyxyDialog from '../modules/dialog/HyxyDialog'
export default {
	name: 'vip',
	components: {
		Titles,
		Headers,
		MyPrivileges,
		// Privileges,
		JobAnalysis,
		Help,
		Footers,
		BuyDialog,
		TbtsDialog, //投保提示
		AuthDialog, //个人认证提示
		HyxyDialog
	},
	data() {
		return {
			show: false,
			showHyxy: false,
			showTbts: false, //投保提示显示
			showAuth: false, //个人认证提示显示
			cardChoose: 58
		}
	},
	props: ['vipState', 'cardState'],
	created() {
	},
	methods: {
		closeDialog() {
			this.show = false
			this.showHyxy = false
			this.showTbts = false
			this.showAuth = false;
		},
		showCompensateDialog (){
			this.closeDialog()
			this.showTbts = true;
		},
		showAuthDialog (){
			this.closeDialog()
			this.showAuth = true;
		},
		showDialog( cardType = 58 ) {
			this.show = true;
			this.cardChoose = cardType
		},
		showHyxyDialog() {
			this.showHyxy = true
		}
	}
}
</script>

<style lang="scss" scope>
@import "../../../assets/css/public.scss"
</style>



// WEBPACK FOOTER //
// Vip.vue?43186376